<template>
  <v-container class="pa-5">
    <div v-if="symposia">
      <v-row justify="center" align="center">
        <span class="text-h4 mb-1">
          {{ symposia.acronym }} -
          {{ symposia.name }}
        </span>
      </v-row>
      <v-row justify="end" v-if="inscriptions.length > 0">
        <v-col cols="4">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('searchField')"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="inscriptions.length > 0">
        <v-col cols="12">
          <div>
            <v-data-table
              @click:row="openInscription"
              :search="search"
              :headers="headers"
              :items="inscriptions"
              item-key="id"
              class="elevation-1"
            >
              <template v-slot:[`item.inscriptionDate`]="{ item }">
                {{ new Date(item.inscriptionDate.seconds * 1000).getDate() }}/{{
                  new Date(item.inscriptionDate.seconds * 1000).getMonth() + 1
                }}/{{
                  new Date(item.inscriptionDate.seconds * 1000).getFullYear()
                }}
              </template>
              <template v-slot:[`item.reviewed`]="{ item }">
                {{ item.reviewed ? "Si" : "No" }}
              </template>
            </v-data-table>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <download-excel :data="inscriptions" :fields="json_fields">
          <v-btn> {{ $t("downloadData") }} </v-btn>
        </download-excel>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { getSymposio } from "@/services/symposiums.js";
import firebase from "firebase";

export default {
  async mounted() {
    if (this.$route.params.symposia) {
      this.symposia = this.$route.params.symposia;
    } else {
      this.symposia = await getSymposio(this.$route.params.symposiaId, this);
    }
    this.getSimposioInscriptions(this.symposia.id);
    //console.log(this.inscriptions);
  },
  data() {
    return {
      symposia: {},
      inscriptions: [],
      search: "",
      json_fields: {
        Name: "name",
        Lastname: "surname",
        Name_for_certificate: "fullName",
        Application_Date: {
          field: "inscriptionDate",
          callback: (value) => {
            return `${new Date(value.seconds * 1000)}`;
          },
        },
        Email: "email",
        Alternate_email: "altEmail",
        Telephone_number: {
          field: "phone",
          callback: (value) => {
            return `${value}`;
          },
        },
        Emergency_contact_information: "emergencyContactInfo",
        Institution_University_Company: "institution",
        Profession_Title: "rol",
        Passport_number: "idNumber",
        Address: "address",
        City: "city",
        Zip_code: "zipCode",
        Country: "country",
        Participated_before: {
          field: "previousAssistance",
          callback: (value) => {
            return value ? "Yes" : "No";
          },
        },
        Received_an_IAP_scholarship_before: {
          field: "previousScholarship",
          callback: (value) => {
            return value ? "Yes" : "No";
          },
        },
        Asked_for_scholarship_this_year: {
          field: "askedScholarshipThisYear",
          callback: (value) => {
            return value ? "Yes" : "No";
          },
        },
        Given_scholarship_this_year: {
          field: "givenScholarshipThisYear",
          callback: (value) => {
            return value ? "Yes" : "No";
          },
        },
        LETTER_EMAILED: {
          field: "letterMailed",
          callback: (value) => {
            return value ? "Yes" : "No";
          },
        },
        CONFIRMATION_LETTER_EMAILED: "confirmationLetterMailed ",
        AMOUNT_OWED: "amountOwed",
        FINAL_AMOUNT_PAID: "finalAmountPaid",
        HOTEL_INFO: "hotelInfo",
        FLIGHT_INFO: "flightInfo",
        Coordinators_note: "coordinatorsNote",
        Reviewed: {
          field: "reviewed",
          callback: (value) => {
            return value ? "Yes" : "No";
          },
        },
      },
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: "Lastname", value: "surname" },
        {
          text: "Date",
          value: "inscriptionDate",
        },
        {
          text: "Nacionality",
          value: "country",
        },
        {
          text: "Email",
          value: "email",
        },
        { text: "Profession", value: "rol" },
        { text: "Institution", value: "institution" },
        { text: "Reviewed", value: "reviewed" },
      ];
    },
  },
  methods: {
    openInscription(item) {
      this.$router.push({
        name: "InscriptionDetail",
        params: {
          inscription: item,
          simposioId: this.symposia.id,
          inscriptionId: item.id,
        },
      });
    },
    async getSimposioInscriptions(id) {
      var querySnapshot = await firebase
        .firestore()
        .collection("symposiums")
        .doc(id)
        .collection("inscriptions2025")
        .get();
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        this.inscriptions.push({ id: doc.id, ...doc.data() });
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
